/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Giorno della settiman, giorni previsti :   -*LUN*: lunedi  -*MAR*: martedi  -*MER*: mercoledi  -*GIO*: giovedi  -*VEN*: venerdi  -*SAB*: sabato  -*DOM*: domenica
 */
export enum GiornoDellaSettimanaEnum {

    LUN = 'LUN',

    MAR = 'MAR',

    MER = 'MER',

    GIO = 'GIO',

    VEN = 'VEN',

    SAB = 'SAB',

    DOM = 'DOM'
}

